import { BridgeComponent } from '@hotwired/hotwire-native-bridge';

// Triggers notification permission request in the native app.
// Added to body tag when user is signed in: <body data-controller="bridge--notification-token">
export default class extends BridgeComponent {
  static component = 'notification-token';

  connect() {
    super.connect();
    if (this.enabled) {
      this.send('register');
    }
  }
}
